import { Typography } from "@mui/material";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import type { Bank } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  bank: Bank;
};

export const NotRecommendedInfobox = ({ bank }: Props) => {
  const { t } = useResource();

  const reason = t(
    Resources.BankRating.Banks[bank].NotRecommended?.Reason ?? "",
  );

  return (
    <InfoBox
      variant="warning"
      content={
        <>
          <Typography
            fontWeight="600"
            color="text.primary"
            textTransform="uppercase"
          >
            {t(Resources.BankRating.NotRecommended.InfoboxTitle)}
          </Typography>
          {reason && (
            <Typography color="text.primary" fontWeight="500">
              {reason}
            </Typography>
          )}
        </>
      }
    />
  );
};
